/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RequiredConstraintConfig } from "./RequiredConstraintConfig";
export const RequiredConstraint = core.serialization.object({
    config: RequiredConstraintConfig.optional(),
});
